import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IconType } from '../../core-data-model/IconType';

@Component({
    selector: 'five-star-rating',
    template: `
        @if (ratingDefinitions) {
            <div class="five-star-container">
                @for (i of scoreIndex; track i) {
                    <span>
                        <abstract-icon
                            class="star-rating-container"
                            [iconType]="getStarState(i)"
                            (click)="clickedStar.emit(i + 1)"
                            tooltip
                            [tooltipContent]="actionRatingDefinitions"
                            [tooltipAnimation]="true"
                            [tooltipDisabled]="false"
                            tooltipPlacement="bottom"
                            [attr.data-testing]="'rating-star-' + (i + 1)"
                        >
                        </abstract-icon>
                        <tooltip-content #actionRatingDefinitions>
                            <div style="margin:10px; font-size:14px;">
                                {{ getRatingDefinitionText(i) }}
                            </div>
                        </tooltip-content>
                    </span>
                }
            </div>
        }
    `,
    styles: [
        `
            .five-star-container {
                font-size: 18px;
                width: max-content;
                display: flex;
            }
            .star-rating-container {
                margin-right: 4px;
                stroke-width: 0;
                height: 20px;
            }
        `
    ],
    standalone: false
})
export class FiveStarRatingComponent {
    @Input()
    rating: number;
    @Input()
    ratingDefinitions: string[];

    @Output()
    clickedStar = new EventEmitter<number>();

    IconType = IconType;

    scoreIndex = [0, 1, 2, 3, 4];

    getStarState(index: number) {
        if (this.rating - 1 >= index) {
            return IconType.StreamlineFullStar;
        } else {
            return IconType.StreamlineEmptyStar;
        }
    }

    getRatingDefinitionText(index: number) {
        return this.ratingDefinitions[index];
    }
}
